/**
 * ProtectedRoute Component - Route guard con controllo ruoli e permessi
 * Redirect a ErrorPage se l'utente non ha i permessi necessari
 */

import React from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { hasAccess, getAccessDeniedMessage } from '../utils/permissions';
import ErrorPage from '../pages/ErrorPage';
import { HTTP_STATUS } from '../utils/constants';

export default function ProtectedRoute({ allowedRoles, section }) {
  const { user, isAuthenticated, loading } = useAuth();
  const location = useLocation();

  // Mostra loader mentre verifica l'autenticazione
  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-anutel"></div>
      </div>
    );
  }

  // Se non autenticato, redirect al login
  if (!isAuthenticated || !user) {
    return <Navigate to="/login" state={{ returnUrl: location.pathname + location.search }} replace />;
  }

  // Sezione non configurata in SECTION_PERMISSIONS: nega l'accesso invece di concederlo di default
  if (!Array.isArray(allowedRoles) || allowedRoles.length === 0) {
    console.error('[ProtectedRoute] Sezione senza permessi configurati:', section);
    return (
      <ErrorPage
        code={HTTP_STATUS.FORBIDDEN}
        message="Accesso Negato"
        description="Sezione non configurata: accesso negato."
        showHomeButton={true}
        showLoginButton={false}
      />
    );
  }

  // Verifica se l'utente ha un idAnagrafico valido
  const hasValidIdAnagrafico =
    user?.idAnagrafico &&
    user.idAnagrafico !== null &&
    user.idAnagrafico !== '' &&
    user.idAnagrafico !== 0 &&
    user.idAnagrafico !== '0';

  // Se l'utente non ha un idAnagrafico valido, permetti solo l'accesso alla sezione PROFILO
  if (!hasValidIdAnagrafico && section !== 'PROFILO') {
    return <Navigate to="/dashboard/profilo" replace />;
  }

  // Verifica l'accesso ai ruoli autorizzati
  const userRoles = user.roles || [];

  if (!hasAccess(userRoles, allowedRoles)) {
    const errorMessage = section
      ? getAccessDeniedMessage(section, userRoles)
      : 'Non hai i permessi necessari per accedere a questa risorsa.';

    return (
      <ErrorPage
        code={HTTP_STATUS.FORBIDDEN}
        message="Accesso Negato"
        description={errorMessage}
        showHomeButton={true}
        showLoginButton={false}
      />
    );
  }

  // Accesso garantito
  return (
    <Outlet />
  );
}
